import { render, staticRenderFns } from "./Storyboards.vue?vue&type=template&id=77ae14c7&scoped=true"
import script from "./Storyboards.vue?vue&type=script&lang=js"
export * from "./Storyboards.vue?vue&type=script&lang=js"
import style0 from "./Storyboards.vue?vue&type=style&index=0&id=77ae14c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae14c7",
  null
  
)

export default component.exports